import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { ActionButton } from 'components/ui/Button';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { StyledInput, MandatoryFieldLabel, ErrorField, Field, StyledSubmitField, StyledForm } from './SearchBooking.styles';

const SearchByPnrForm = ({ onSubmitSearch }) => {
  const { register, handleSubmit, formState, setFocus } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange'
  });

  const { errors } = formState;

  useEffect(() => setFocus('reference'), [setFocus]);

  return (
    <StyledForm onSubmit={handleSubmit(onSubmitSearch)}>
      <Field>
        <MandatoryFieldLabel htmlFor="reference">
          <FormattedMessage id="searchBooking.pnr" />
        </MandatoryFieldLabel>
        <StyledInput
          {...register('reference', {
            required: true,
            pattern: /^[a-zA-Z0-9_" "]{5,25}$/
          })}
          type="text"
          id="reference"
          maxLength="25"
          validationState={errors.reference ? 'error' : ''}
        />
        {errors.reference && (
          <ErrorField id="error-pnr">
            <FormattedMessage id="searchBooking.pnrValidationMessage" />
          </ErrorField>
        )}
      </Field>
      <StyledSubmitField>
        <ActionButton data-cy="pnr-search" type="submit" disabled={!formState.isValid}>
          <FormattedMessage id="searchBooking.search" />
        </ActionButton>
      </StyledSubmitField>
    </StyledForm>
  );
};

SearchByPnrForm.propTypes = {
  onSubmitSearch: PropTypes.func
};

export default SearchByPnrForm;
